import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ToastMessage } from './toast-message.model';

@Component({
  selector: 'app-simple-toast-group',
  templateUrl: './simple-toast-group.component.html',
  styleUrls: ['./simple-toast-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleToastGroupComponent {
  @Input()
  messages: ToastMessage[] = [];
  @Output()
  readonly dismiss = new EventEmitter<ToastMessage>();

  onDismiss(message: ToastMessage, event: CustomEvent<void>): void {
    event.preventDefault();
    this.dismiss.emit(message);
  }
}
